import { saveResource } from '../../library/dg-super-app-bridge'
// import { selectFileBase64 } from 'dg-super-app-bridge'

export const isDgSuperApp = (): boolean => {
  const { userAgent } = window.navigator
  return userAgent.indexOf('DgSuperApp') !== -1
}

export function base64ToText(base64String: string): string {
  try {
    let cleanInput = base64String.replace(/\s/g, '')
    while (cleanInput.length % 4 !== 0) cleanInput += '='
    return Buffer.from(cleanInput, 'base64').toString('utf-8')
  } catch (error) {
    return `Error decoding: ${
      error instanceof Error ? error.message : 'Unknown error'
    }`
  }
}

export async function blobToBase64(blob: Blob): Promise<string> {
  const base64Data = await new Promise<string>((resolve) => {
    const reader = new FileReader()
    reader.onload = () => {
      const base64 = reader.result as string
      resolve(base64.split(',')[1])
    }
    reader.readAsDataURL(blob)
  })
  return base64Data
}

export function getFilenameAndExtension(fileName: string): {
  name: string
  extension: string
} {
  const lastDotIndex = fileName.lastIndexOf('.')
  if (
    lastDotIndex === -1 ||
    lastDotIndex === 0 ||
    lastDotIndex === fileName.length - 1
  ) {
    // No extension or filename starts/ends with a dot
    return { name: fileName, extension: '' }
  }

  const name = fileName.substring(0, lastDotIndex)
  const extension = fileName.substring(lastDotIndex + 1)

  return { name, extension }
}

export function getFileNameAndExtFullPath(fullPath: string): {
  name: string
  ext: string
} {
  const lastSegment = fullPath.split(/[/\\]/).pop() ?? ''
  const dotIndex = lastSegment.lastIndexOf('.')
  if (dotIndex === -1) {
    return { name: lastSegment, ext: '' }
  }
  const name = lastSegment.slice(0, dotIndex)
  const ext = lastSegment.slice(dotIndex + 1)
  return { name, ext }
}

export const downloadResponseAttachmentOfSuperApp = async (
  blob: Blob,
  submissionId: string,
) => {
  const base64Data = await blobToBase64(blob)
  return saveResource('RefNo ' + submissionId, base64Data, 'anyFile', 'zip')
}
